import type { PageResult } from '@/types/crud'

interface PagePayload {
  list?: unknown
  records?: unknown
  total?: unknown
}

export class PageResultStructureError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'PageResultStructureError'
  }
}

export function normalizePageResult<T>(payload: unknown): PageResult<T> {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    throw new PageResultStructureError('分页响应必须是对象')
  }

  const page = payload as PagePayload
  const records = Array.isArray(page.records) ? page.records : page.list
  if (!Array.isArray(records)) {
    throw new PageResultStructureError('分页响应缺少 list 或 records 数组')
  }

  const total =
    typeof page.total === 'number'
      ? page.total
      : typeof page.total === 'string' && page.total.trim() !== ''
      ? Number(page.total)
      : Number.NaN

  if (!Number.isInteger(total) || total < 0) {
    throw new PageResultStructureError('分页响应 total 必须是非负整数')
  }

  return {
    records: records as T[],
    total
  }
}
